import styled from "styled-components";

// Components
// import FooterInformation from "./bodyResults/FooterInformation";
import PerformanceAnalysis from "./bodyResults/PerformanceAnalysis";
import SkillsProfile from "./bodyResults/SkillsProfile";
import FeedbackByAttribute from "./bodyResults/FeedbackByAttribute";

const BodyResults = ({ answersFeedback, test }) => {

    return (
        <Container>
            <h1>Resultado del Test de Conocimientos</h1>
            <h2>Competencia: {test?.name ?? answersFeedback?.skill_test?.name ?? answersFeedback?.skill_test_name}</h2>
            <PersonalInfo>
                <label><b>Nombre:</b> {answersFeedback?.name ?? answersFeedback?.participant_name}</label>
                <label><b>Email:</b> {answersFeedback?.email ?? answersFeedback?.participant_email}</label>
                <label><b>Puesto:</b> {answersFeedback?.job_position ?? answersFeedback?.participant_job_position}</label>
            </PersonalInfo>
            <h3>Puntuación general de <b>{answersFeedback.ai_score}</b>/100</h3>
            <PerformanceAnalysis answersFeedback={answersFeedback} />
            <SkillsProfile attributes={answersFeedback?.ai_profile} />
            <FeedbackByAttribute attributes={answersFeedback?.ai_profile} />
            {/* <GridSkillsStates /> */}
            {/* <FooterInformation answersFeedback={answersFeedback} /> */}
        </Container>
    )
}

export default BodyResults;

const Container = styled.div`
    width: 60vw;
    height: 100%;
    background-color: #FFF;
    border-radius: 30px;
    padding: 3rem;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
    gap: 24px;

    @media (width < 1000px) {
        width: calc(100% - 6rem);
        padding: 2rem;
    }

    h1 {
        font-size: 24px;
        font-weight: 700;
        color: #1D1D18;
    }

    h2 {
        font-size: 20px;
        font-weight: 700;
        color: #b31d15;
    }

    h3 {
        width: 100%;
        font-size: 24px !important;
        text-align: center;
        font-weight: 500;
        color: #1D1D18;

        b {
            font-size: 24px;
        }
    }
`

const PersonalInfo = styled.div`
    width: calc(100% - 6rem);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: start;
    gap: 1rem;
    background-color: #f1f1f1;
    padding: 2rem;
    border-radius: 20px;
`

const Grid = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem;
`;

const Card = styled.div`
    width: calc(100% - 40px);
    height: 400px;
    background: linear-gradient(180deg, #B31D15 1%, #c22c10 100%);
    border-radius: 30px;
    padding: 20px;
    color: white;
    text-align: center;
`;